import axios from 'utils/axiosInstance'

const BASE_URL_ENDPOINT = '/grupo_interes/cargas_grupo_interes'

const getCargasGI = async (busqueda = '') => {
  const response = await axios.get(`${BASE_URL_ENDPOINT}/?search=${busqueda}`)
  return response.data
}

const crearCargaGI = async (values) => {
  const { data, onSuccess: onSuccessMessage } = await axios.post(
    `${BASE_URL_ENDPOINT}/`,
    values,
  )
  return { data, onSuccessMessage }
}

const eliminarCargaGI = async ({ id, nombre }) => {
  const { onSuccess: onSuccessMessage } = await axios.delete(
    `${BASE_URL_ENDPOINT}/${id}`,
  )
  return { data: nombre || id, onSuccessMessage }
}

const actualizarCargaGI = async ({ id, values }) => {
  const { data, onSuccess: onSuccessMessage } = await axios.put(
    `${BASE_URL_ENDPOINT}/${id}/`,
    values,
  )
  return { data, onSuccessMessage }
}

export {
  getCargasGI,
  crearCargaGI,
  eliminarCargaGI,
  actualizarCargaGI,
}